module.exports = __webpack_public_path__ + "static/8-0c050de601dae69a51b9ef0bb7d37eb0.png";